import { render, staticRenderFns } from "./AiBookUserCategory.vue?vue&type=template&id=14698f68&scoped=true"
import script from "./AiBookUserCategory.vue?vue&type=script&lang=js"
export * from "./AiBookUserCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14698f68",
  null
  
)

export default component.exports